import { styled } from '@mui/material/styles';
import { ArrowDownIcon } from 'assets/images/icons';

export const MenuTinyArrow = styled(ArrowDownIcon, { shouldForwardProp: prop => prop !== 'isUp' })(({ isUp }) => ({
    width: 4,
    marginLeft: 6,
    '& path': {
        fill: '#416774',
        fillOpacity: 1,
    },
    ...(isUp && {
        transform: 'rotate(180deg)',
    }),
}));
